import React, { FC, useCallback } from "react";
import F7 from "../../../utils/F7";
import ListBlock from "../F7/ListBlock";
import ListBlockItem from "../F7/ListBlockItem";
import { useNavigate } from "react-router-dom";

const SidebarMenu: FC = () => {
  const handleCloseClick = useCallback(() => F7.closePanel(), []);

  const navigate = useNavigate();
  const handleMapClick = useCallback(() => {
    navigate("");
    F7.closePanel();
  }, [navigate]);

  return (
    <div>
      <i className="fa fa-chevron-left" onClick={handleCloseClick} style={{ fontSize: 25, marginLeft: 10, marginTop: 10 }} />
      <div className="content-block-title">Menu</div>
      <ListBlock>
        <ListBlockItem title="Map" onClick={handleMapClick} />
        <ListBlockItem title="Projects" to="../p" />
        <ListBlockItem title="Offline maps" to="offline-maps" />
        <ListBlockItem title="Sync" to="../sync" />
        <ListBlockItem title="Logout" to="/logout" />
        <ListBlockItem title="About" to="/about" />
      </ListBlock>
    </div>
  );
};
export default SidebarMenu;
